import axios from 'axios'

// 添加日记
export const addDiary = (userName, diaryData) => {
  return axios.post(`/diaries/user/${userName}/addDiaries`, diaryData)
}

// 更新日记
export const updateDiary = (id, userName, diaryData) => {
  return axios.put(`/diaries/user/${userName}/updateDiaries/${id}`, diaryData)
}

// 查询日记（分页，默认每页20条，倒序）
export const getDiaries = (userName, pageNo = 1, pageSize = 20) => {
  return axios.get(`/diaries/user/${userName}/getDiaries`, {
    params: { pageNo, pageSize }
  })
}

// 删除日记
export const deleteDiary = (id) => {
  return axios.delete(`/diaries/deleteDiaries/${id}`)
}
